export const initItem = {
  item: "",
  audio: false,
  item_id: 0,
  proposals: [
    {
      proposal: "",
      proposal_id: "",
    },
    {
      proposal: "",
      proposal_id: "",
    },
  ],
}

export const initExtra = {
  current: 0,
  native_language: null,
  wholesome_conditions: null,
  elapsed_time: 0,
  isRestarting: null,
  all_items_completed: false,
  last_screen_showed: false,
  finished: false,
  trigger_events: true,
}

export const initAnswers = {
  version: "",
  is_completed: false,
  is_active: true,
  status: "todo",
  locale_id: 0,
  user: {
    uuid: "",
    first_name: "",
    email: "",
    is_recruiter: false,
    is_guest: false,
    gender: "",
  },
  audio: false,
  data: {
    tutorial_time: {
      step_1: 0,
      step_2: 0,
      step_3: 0,
      step_4: 0,
      finished: false,
    },
    trial: {
      step_1: {
        time: 0,
        errors: 0,
      },
      step_2: {
        time: 0,
        errors: 0,
      },
      step_3: {
        time: 0,
        errors: 0,
      },
      retries: 0,
      finished: false,
    },
    items: [],
    extra: initExtra,
  },
  permissions: [],
}

const factoryItem = (id: number) => ({
  answer: `psv20_proposal_${id}_2`,
  audio: false,
  device_type: "desktop",
  screen_width: 1920,
  time_initial: 0.2,
})

export const factoryPatch = {
  version: "en_US_2.0.0",
  langCode: "en_US",
  locale_id: 3,
  status: "inprogress",
  data: {
    items: [
      factoryItem(1),
      factoryItem(2),
      factoryItem(3),
      factoryItem(4),
      factoryItem(5),
      factoryItem(6),
      factoryItem(7),
      factoryItem(8),
      factoryItem(9),
      factoryItem(10),
      factoryItem(11),
      factoryItem(12),
      factoryItem(13),
      factoryItem(14),
      factoryItem(15),
      factoryItem(16),
      factoryItem(17),
      factoryItem(18),
      factoryItem(19),
      factoryItem(20),
      factoryItem(21),
      factoryItem(22),
      factoryItem(23),
      factoryItem(24),
      factoryItem(25),
      factoryItem(26),
      factoryItem(27),
      factoryItem(28),
      factoryItem(29),
      factoryItem(30),
      factoryItem(31),
      factoryItem(32),
      factoryItem(33),
      factoryItem(34),
      factoryItem(35),
      factoryItem(36),
      factoryItem(37),
      factoryItem(38),
      factoryItem(39),
      factoryItem(40),
      factoryItem(41),
      factoryItem(42),
      factoryItem(43),
      factoryItem(44),
      factoryItem(45),
      factoryItem(46),
      factoryItem(47),
      factoryItem(48),
      factoryItem(49),
      factoryItem(50),
      factoryItem(51),
      factoryItem(52),
      factoryItem(53),
      factoryItem(54),
      factoryItem(55),
      factoryItem(56),
      factoryItem(57),
      factoryItem(58),
      factoryItem(59),
      factoryItem(60),
      factoryItem(61),
      factoryItem(62),
      factoryItem(63),
      factoryItem(64),
      factoryItem(65),
      factoryItem(66),
      factoryItem(67),
      factoryItem(68),
      factoryItem(69),
      factoryItem(70),
      factoryItem(71),
      factoryItem(72),
      factoryItem(73),
      factoryItem(74),
      factoryItem(75),
      factoryItem(76),
      factoryItem(77),
      factoryItem(78),
      factoryItem(79),
      factoryItem(80),
      factoryItem(81),
      factoryItem(82),
      factoryItem(83),
      factoryItem(84),
      factoryItem(85),
      factoryItem(86),
      factoryItem(87),
      factoryItem(88),
    ],
    extra: { ...initExtra },
  },
}

export const factoryReset = {
  version: "en_US_2.0.0",
  langCode: "en_US",
  locale_id: 2,
  status: "todo",
  data: {
    items: [],
    extra: { ...initExtra },
  },
}

export const factoryTest = (locale_id: number, restarting: boolean) => {
  return {
    version: "en_US_1.0.0",
    locale_id: locale_id,
    data: {
      extra: {
        current: 73,
        all_items_completed: false,
        isRestarting: restarting,
        finished: false,
        elapsed_time: 0,
        native_language: null,
        trigger_events: true,
        wholesome_conditions: null,
      },
      items: [
        {
          item_id: "swipe_v1_item_01",
          time_initial: 1.241,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_01_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_02",
          time_initial: 0.11,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_02_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_03",
          time_initial: 0.546,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_03_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_04",
          time_initial: 0.054,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_04_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_05",
          time_initial: 0.059,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_05_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_06",
          time_initial: 0.008,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_06_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_07",
          time_initial: 0.192,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_07_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_08",
          time_initial: 0.087,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_08_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_09",
          time_initial: 0.012,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_09_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_10",
          time_initial: 0.236,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_10_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_11",
          time_initial: 0.041,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_11_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_12",
          time_initial: 0.196,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_12_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_13",
          time_initial: 0.089,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_13_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_14",
          time_initial: 0.205,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_14_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_15",
          time_initial: 0.048,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_15_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_16",
          time_initial: 0.227,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_16_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_17",
          time_initial: 0.242,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_17_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_18",
          time_initial: 0.061,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_18_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_19",
          time_initial: 0.022,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_19_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_20",
          time_initial: 0.234,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_20_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_21",
          time_initial: 0.012,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_21_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_22",
          time_initial: 0.079,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_22_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_23",
          time_initial: 0.051,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_23_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_24",
          time_initial: 0.203,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_24_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_25",
          time_initial: 0.066,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_25_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_26",
          time_initial: 0.015,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_26_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_27",
          time_initial: 0.255,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_27_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_28",
          time_initial: 0.291,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_28_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_29",
          time_initial: 0.222,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_29_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_30",
          time_initial: 0.004,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_30_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_31",
          time_initial: 0.047,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_31_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_32",
          time_initial: 0.014,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_32_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_33",
          time_initial: 0.008,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_33_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_34",
          time_initial: 0.01,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_34_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_35",
          time_initial: 0.017,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_35_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_36",
          time_initial: 0.214,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_36_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_37",
          time_initial: 0.013,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_37_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_38",
          time_initial: 0.088,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_38_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_39",
          time_initial: 0.012,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_39_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_40",
          time_initial: 0.031,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_40_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_41",
          time_initial: 0.241,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_41_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_42",
          time_initial: 0.227,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_42_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_43",
          time_initial: 0.306,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_43_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_44",
          time_initial: 0.041,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_44_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_45",
          time_initial: 0.013,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_45_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_46",
          time_initial: 0.207,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_46_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_47",
          time_initial: 0.202,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_47_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_48",
          time_initial: 0.029,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_48_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_49",
          time_initial: 0.017,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_49_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_50",
          time_initial: 0.202,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_50_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_51",
          time_initial: 0.262,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_51_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_52",
          time_initial: 0.138,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_52_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_53",
          time_initial: 0.197,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_53_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_54",
          time_initial: 0.012,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_54_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_55",
          time_initial: 0.024,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_55_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_56",
          time_initial: 0.204,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_56_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_57",
          time_initial: 0.05,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_57_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_58",
          time_initial: 0.056,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_58_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_59",
          time_initial: 0.07,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_59_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_60",
          time_initial: 0.042,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_60_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_61",
          time_initial: 0.042,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_61_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_62",
          time_initial: 0.11,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_62_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_63",
          time_initial: 0.429,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_63_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_64",
          time_initial: 0.094,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_64_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_65",
          time_initial: 0.519,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_65_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_66",
          time_initial: 0.974,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_66_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_67",
          time_initial: 1.649,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_67_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_68",
          time_initial: 1.267,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_68_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_69",
          time_initial: 1.69,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_69_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_70",
          time_initial: 1.147,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_70_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_71",
          time_initial: 1.176,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_71_1",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_72",
          time_initial: 4.388,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_72_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
        {
          item_id: "swipe_v1_item_73",
          time_initial: 1.429,
          answer_initial: null,
          time_x1: 0,
          time_final: 0,
          answer: "swipe_v1_proposal_73_2",
          bolt_back: 0,
          device_type: "desktop",
          screen_width: 3840,
          audio: false,
        },
      ],
      trial: {
        step_1: {
          time: 1.782,
          errors: 0,
        },
        step_2: {
          time: 0.469,
          errors: 0,
        },
        step_3: {
          time: 0,
          errors: 0,
        },
        retries: 0,
        finished: true,
      },
      tutorial_time: {
        step_1: 1.408,
        step_2: 0.579,
        step_3: 0,
        step_4: 0,
        finished: true,
      },
    },
  }
}
